/* globals bootstrap */
$(() => {
  $('[data-bs-toggle="tooltip"]').each((i, e) => new bootstrap.Tooltip(e));
});
